import React from "react";
import MuiAppBar from "@material-ui/core/AppBar";
import { Container, createStyles, makeStyles, Theme } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { ComponentItemProp } from "../ModuleProps";
import { OfqualLogo } from "./OfqualLogo";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      [theme.breakpoints.up("md")]: {
        width: (props) => `calc(100% - ${props}px)`,
        marginLeft: theme.layoutDimensions.mainDrawerWidth,
      },
      height: theme.layoutDimensions.mainAppBarHeight,
      [theme.breakpoints.up("lg")]: {
        "& .MuiToolbar-gutters": {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("lg")]: {
        display: "none",
      },
    },
    title: {
      [theme.breakpoints.up("md")]: {
        // display: "none",
      },
      color: "#000",
    },
    logoZone: {
      width: theme.layoutDimensions.mainDrawerWidth || "200px",
      paddingTop: 10,
      paddingLeft: theme.layoutDimensions.mainDrawerWidth === 0 ? 0 : 75,
      height: 50,
      minHeight: 50,
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    container: {
      padding: 0,
      margin: theme.layoutDimensions.mainDrawerWidth === 0 ? undefined : 0,
      maxWidth:
        theme.breakpoints.values.xl + theme.layoutDimensions.mainDrawerWidth,
    },
  })
);

type AppBarProps = {
  handleDrawerToggle: () => void;
  toolbarItems: ComponentItemProp[];
};

export const AppBar: React.FC<AppBarProps> = ({
  handleDrawerToggle,
  toolbarItems,
}) => {
  const classes = useStyles();
  return (
    <MuiAppBar position="fixed" className={classes.appBar}>
      <Container maxWidth="xl" className={classes.container}>
        <Toolbar className="-AppBar">
          <div className={classes.logoZone}>
            <OfqualLogo />
          </div>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h1" noWrap className={classes.title}>
            The Portal
          </Typography>
          <div className="AppBarActions">
            {toolbarItems.map((toolbarItem) => {
              return (
                <toolbarItem.module.component
                  key={toolbarItem.module.redux.name}
                />
              );
            })}
          </div>
        </Toolbar>
      </Container>
    </MuiAppBar>
  );
};
